<script lang="ts">
  import type { FormChoiceType } from "@shared/common/node/type";

  import { getImageLabelFromIndex } from "@shared/common/utils/form";
  import { simpleRandomId } from "../../../util/common";
  import FormCheckbox from "./form-checkbox.svelte";

  export let name: string;
  export let required: boolean | undefined = undefined;
  export let url: string = "";
  export let index: number;
  export let type: FormChoiceType = "CHECKBOX";
  export let id: string = simpleRandomId();
</script>

<div class="form-image-option">
  <FormCheckbox
    type={type === "CHECKBOX" ? "checkbox" : "radio"}
    {id}
    {name}
    {required}
    value={getImageLabelFromIndex(index)}
  />
  <label for={id}>
    <img src={url} alt={url} />
  </label>
</div>

<style>
  .form-image-option {
    display: flex;
    flex-basis: var(--cb-form-image-choice-flex-basis);
    padding: 0 calc(var(--cb-form-font-size) * 1)
      calc(var(--cb-form-font-size) * 0.5) 0;
    color: rgba(var(--cb-form-font-color), 1);
    font-size: var(--cb-form-font-size);
    gap: calc(var(--cb-form-font-size) * 0.5);
  }

  .form-image-option img {
    width: 100%;
    height: 100%;
  }
</style>
